import { ChangeEvent, ReactNode } from 'react';
import { useSearchParams } from 'react-router';
import { useDebounce } from '@/utils/use-debounce';
import { ActionIcon, Flex, TextInput } from '@mantine/core';
import { IconRotate, IconSearch } from '@tabler/icons-react';


export function SubscriptionsListFilters({ onClickRefresh }: { onClickRefresh?: () => void }): ReactNode {
    const debounce = useDebounce(500);
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.value) {
            setSearchParams((prev) => {
                prev.set('page', '1');
                prev.delete('search');
                return prev;
            });
            return;
        }
        if (e.target.value.length > 2) {
            debounce(() => {
                setSearchParams((prev) => {
                    prev.set('page', '1');
                    prev.set('search', e.target.value);
                    return prev;
                });
            })
        }
    }
    
    return (
        <Flex
            style={ { marginTop: 8, width: '100%' } }
            gap={ 8 }
        >
            <TextInput
                placeholder='Search'
                leftSection={ <IconSearch size={14}/> }
                defaultValue={ searchParams.get('search') || '' }
                onChange={ onChangeSearch }
                style={ { flex: 1 }}
            />
            <ActionIcon
                onClick={ onClickRefresh }
            >
                <IconRotate />
            </ActionIcon>
        </Flex>
    );
}